require('./bootstrap');

require('chosen-js');
require('bootstrap-datepicker');

import Vue from 'vue/dist/vue';
window.Vue = Vue;

import VueResource from 'vue-resource';
Vue.use(VueResource);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


Vue.http.interceptors.push((request, next) => {
    request.headers.set('X-CSRF-TOKEN', AvNets.csrfToken);
    next();
});

// Register components
/*Vue.component('modal', require('./components/utils/modal.vue'));*/
Vue.component('av-select', require('./components/utils/av-select.vue').default);
Vue.component('av-selectable', require('./components/utils/av-selectable.vue').default);
Vue.component('av-chosen', require('./components/utils/av-chosen.vue').default);
Vue.component('av-date', require('./components/utils/av-date.vue').default);
